import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import LanguageSelector from "../Languages/LanguageSelector";

const privacyPolicyData = {
  title: "Privacy Policy",
  lastUpdated: "January 2026",
  appName: "Fetan Delivery",
  intro:
    'Fetan Delivery ("we", "our", "us") operates the Fetan Delivery Portal, a delivery application that connects customers, delivery partners, and merchants. This Privacy Policy explains how we collect, use, and protect your information when you use our services.',
  sections: [
    {
      heading: "Information We Collect",
      points: [
        {
          title: "Personal Information",
          items: [
            "Full name",
            "Phone number",
            "Email address",
            "Delivery address",
            "Account login credentials",
          ],
        },
        {
          title: "Location Information",
          items: [
            "Real-time delivery tracking",
            "Pickup and drop-off locations",
          ],
        },
        {
          title: "Transaction Information",
          items: [
            "Order details",
            "Delivery history",
            "Payment status (we do not store card details)",
          ],
        },
      ],
    },
    {
      heading: "How We Use Your Information",
      items: [
        "Create and manage user accounts",
        "Process and deliver orders",
        "Enable real-time tracking",
        "Send order updates and notifications",
        "Improve app performance and user experience",
        "Provide customer support",
        "Prevent fraud and ensure security",
      ],
    },
    {
      heading: "Sharing of Information",
      items: [
        "Delivery partners to complete deliveries",
        "Merchants to prepare orders",
        "Trusted service providers",
        "Legal authorities when required by law",
      ],
    },
    {
      heading: "Data Security",
      content:
        "We implement reasonable technical and organizational measures to protect your personal information. However, no system is completely secure.",
    },
    {
      heading: "Children’s Privacy",
      content:
        "Fetan Delivery is not intended for individuals under the age of 18, and we do not knowingly collect data from children.",
    },
    {
      heading: "Contact Us",
      content: "Email: support@fetandelivery.com",
    },
  ],
};

const PrivacyPolicy = () => {
  return (
    <>
      <div
        className="navbar-expand-lg navbar-light  fixed-top"
        style={{ zIndex: "99999" }}
      >
        <LanguageSelector />
      </div>
      <Header />
      <div className="container py-5 " style={{ marginTop: "70px" }}>
        <h1 className="text-light">{privacyPolicyData.title}</h1>
        <p className="text-muted">
          <strong>Last updated:</strong> {privacyPolicyData.lastUpdated}
        </p>

        <p className="mt-4 ">{privacyPolicyData.intro}</p>

        {privacyPolicyData.sections.map((section, index) => (
          <div key={index} className="mt-4">
            <h4 className="text-light">{section.heading}</h4>

            {/* Grouped bullet sections */}
            {section.points &&
              section.points.map((group, i) => (
                <div key={i} className="mt-2">
                  <strong>{group.title}</strong>
                  <ul>
                    {group.items.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                </div>
              ))}

            {/* Simple bullet list */}
            {section.items && (
              <ul>
                {section.items.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            )}

            {/* Paragraph content */}
            {section.content && <p>{section.content}</p>}
          </div>
        ))}
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
